

























































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

interface RoRow {
  id: number;
  date_str: string;
  minutes: number | null;
}

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class OtherMedical3 extends Vue {
  @Prop() tab!: MedicalSpecification;

  // 特地ロ 日別データ（notices_special_other_text から解析して管理）
  private roRows: RoRow[] = [];
  private syncing = false;
  private nextRowId = 1;

  mounted() {
    this.roRows = this.parseRoText(this.tab.notices_special_other_text);
  }

  @Watch("tab.notices_special_other_text")
  onRoTextChanged(newVal: string) {
    // syncRoRows() による自己更新は無視する
    if (this.syncing) return;
    this.roRows = this.parseRoText(newVal);
  }

  private parseRoText(text: string): RoRow[] {
    if (!text) return [];
    return text
      .split("\n")
      .filter(line => line.includes(","))
      .map(line => {
        const parts = line.split(",");
        return {
          id: this.nextRowId++,
          date_str: parts[0] ? parts[0].trim() : "",
          minutes: parts[1] ? Number(parts[1].trim()) : null
        };
      });
  }

  private syncRoRows() {
    this.syncing = true;
    this.tab.notices_special_other_text = this.roRows
      .filter(row => row.date_str || row.minutes !== null)
      .map(row => `${row.date_str},${row.minutes ?? ""}`)
      .join("\n");
    this.$nextTick(() => {
      this.syncing = false;
    });
  }

  private addRoRow() {
    this.roRows.push({ id: this.nextRowId++, date_str: "", minutes: null });
    this.syncRoRows();
  }

  private deleteRoRow(idx: number) {
    this.roRows.splice(idx, 1);
    this.syncRoRows();
  }

  private addEmergencyReason() {
    this.tab.emergency_reasons.push({
      id: 0,
      medical_specification_id: this.tab.id,
      office_id: this.tab.office_id,
      date_str: "",
      text: "",
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
    return;
  }
  private delEmergencyReason(idx: number) {
    this.tab.emergency_reasons.splice(idx, 1);
    return;
  }
}
